import { useQuery } from "@tanstack/react-query";
import { useSession } from "@/frontend/auth-client";
import { orpc } from "@/frontend/orpc-client";
import { ACCOUNT_TYPE } from "@/server/constants/persona";
import { ORG_ENVIRONMENT, type WorkspacePersona } from "@/frontend/types/org";

/**
 * Which onboarding workflow the active workspace belongs to. Individual is a
 * property of the workspace and not of the person, so persona branches read it
 * from here rather than from the session. It shares a query key with
 * `PersonaGate`, so the branch costs no extra request.
 */
export function useWorkspacePersona(): WorkspacePersona {
  const { data: session } = useSession();
  const activeOrgQuery = useQuery({
    ...orpc.org.getFullOrganization.queryOptions({ input: {} }),
    enabled: !!session,
  });

  const activeOrg = activeOrgQuery.data;
  return {
    isIndividual: activeOrg?.accountType === ACCOUNT_TYPE.INDIVIDUAL,
    isLoading: !session || activeOrgQuery.isPending,
    organizationId: activeOrg?.id ?? null,
    organizationName: activeOrg?.name ?? null,
    environment: activeOrg?.environment ?? ORG_ENVIRONMENT.PRODUCTION,
  };
}
